module.exports = __webpack_public_path__ + "img/SearchOnlineCarsLogoColor.d235490b.svg";